import * as React from 'react';
import { SVGProps } from 'react';

const IconFileSchemeSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m10 1.803 3.203 3.114H15v7H8.471a3 3 0 0 1-5.942 0H1v-7h5.797L10 1.803ZM6.789 5.917H2v5h.543A2.918 2.918 0 0 1 5.417 8.5h.166a2.918 2.918 0 0 1 2.874 2.417H14v-5h-.789L10 9.217l-3.211-3.3Zm5.504-.49L10 3.197l-2.293 2.23L10 7.783l2.293-2.356ZM7.5 11.417A1.917 1.917 0 0 0 5.583 9.5h-.166A1.917 1.917 0 0 0 3.5 11.417v.083a2 2 0 1 0 4 0v-.083Z"
    />
  </svg>
);
export default IconFileSchemeSizeS;
